'use client'

// src/constants/limits.ts
var TABBY_EVENT_MIN_TOTAL_AMOUNT = 300;
var MAX_PAYMENT_AMOUNT = 5e5;

export {
  TABBY_EVENT_MIN_TOTAL_AMOUNT,
  MAX_PAYMENT_AMOUNT
};
//# sourceMappingURL=chunk-X5IPJRCS.mjs.map